import React from 'react';

import styles from './LoadError.module.less';

export default ({ offset = 0 }) => {
  return (
    <div className={styles.LoadError} style={{ paddingTop: `${180 + offset}px` }}>
      <img src={require('./error.svg')} alt="" />
      <p>抱歉，出错了，请稍后再试！</p>
    </div>
  );
};
